module.exports = __webpack_public_path__ + "img/emoji/smug.910c3615059ee4069c252833fd45cb5b.png";